import React from "react";

import "../../../style/components/dialogs/enable-paid-features/account-linking.module.css";

export interface PricingData {
    mauRange: string;
    calculation?: string;
    price: string;
}

const AccountLinkingPricingExample = ({ config }: { config: PricingData[] }) => {
    return (
        <div className="pricingExample">
            <h4 className="title">Pricing example</h4>
            <ul className="pricingList">
                {config.map((item: PricingData, index: number) => (
                    <li key={index} className="pricingItem">
                        <p>
                            <span>
                                If you have <strong>{item.mauRange} MAUs, </strong>
                            </span>{" "}
                            <span> that will be </span> {item.calculation && <span> {item.calculation} = </span>}{" "}
                            <strong>{item.price}</strong>
                        </p>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default AccountLinkingPricingExample;
